import { useState, useRef } from "react";
import { Row, Col } from "react-bootstrap";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { MdKeyboardArrowLeft } from "react-icons/md";
import { toast } from "react-toastify";
import Navigation from "../Navigation/Navigation";
import PrivacyTermsConditions from "../../Components/PrivacyTermsConditions/PrivacyTermsConditions";
import { VerifyBusinessOtp } from "../../Utils/Api/VerifyBusinessOtp";
import { ResendBusinessOtp } from "../../Utils/Api/ResendBusinessOtp";
import "./MyProfileAddBussinessOTP.css";

const MyProfileAddBussinessPageOtp = () => {
  const navigate = useNavigate();
  const location = useLocation();

  // RECEIVE DATA FROM PREVIOUS PAGE
  const { link_business_email, primary_bu_id } = location.state || {};

  const [otp, setOtp] = useState(["", "", "", "", "", ""]);
  const inputRefs = useRef([]);

  /* ---------------- CLEAR OTP ---------------- */
  const clearOtp = () => {
    setOtp(["", "", "", "", "", ""]);
    inputRefs.current[0]?.focus();
  };

  /* ---------------- OTP INPUT HANDLERS ---------------- */
  const handleChange = (e, index) => {
    const value = e.target.value.replace(/\D/g, "");

    const newOtp = [...otp];
    newOtp[index] = value;
    setOtp(newOtp);

    if (value && index < 5) {
      inputRefs.current[index + 1].focus();
    }
  };

  const handleKeyDown = (e, index) => {
    if (e.key === "Backspace") {
      const newOtp = [...otp];

      if (newOtp[index]) {
        newOtp[index] = "";
        setOtp(newOtp);
      } else if (index > 0) {
        inputRefs.current[index - 1].focus();
      }
    }
  };

  /* ---------------- VERIFY OTP ---------------- */
  const handleVerify = async () => {
    const otpValue = otp.join("");

    if (otpValue.length !== 6) {
      toast.error("Please enter 6-digit Verification code", {
        theme: "dark",
        position: "top-center",
        width: "500px",
        autoClose: 6000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      return;
    }

    const payload = {
      link_business_email,
      primary_bu_id,
      otp: Number(otpValue),
    };

    const res = await VerifyBusinessOtp(payload);

    if (!res) {
      toast.error("Server error", {
        theme: "dark",
        position: "top-center",
        width: "500px",
        autoClose: 6000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      return;
    }

    if (res.success) {
      toast.success("Business added successfully", {
        theme: "dark",
        position: "top-center",
        width: "500px",
        autoClose: 6000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      navigate("/my-profile/manage-business", {
        state: { refresh: true },
      });
    } else {
      toast.error(res.message || "Please enter a valid Verification code", {
        theme: "dark",
        position: "top-center",
        width: "500px",
        autoClose: 6000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    }
  };

  /* ---------------- RESEND OTP ---------------- */
  const handleResend = async () => {
    clearOtp(); // CLEAR OTP FIRST

    const res = await ResendBusinessOtp({
      link_business_email,
    });

    if (res?.success) {
      toast.success("Verification code resent successfully" , {
        theme: "dark",
        position: "top-center",
        width: "500px",
        autoClose: 6000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    } else {
      toast.error("Failed to resend Verification code" , {
        theme: "dark",
        position: "top-center",
        width: "500px",
        autoClose: 6000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    }
  };

  return (
    <>
      <div className="gray-bg">
        <div className="navbar-section p-0">
          <Navigation />
        </div>

        <div className="main-content pt-5 pr-3 pb-4">
          <p className="page-text dashboard">
            <Link to="/my-profile/manage-business">
              <MdKeyboardArrowLeft className="arrow-left" />
              Back
            </Link>
          </p>

          <p className="page-maintitle">Enter Business Verification code</p>

          <div className="acc-dashboard mt-4">
            <Row className="mt-5 mb-5">
              <Col md={3} />
              <Col md={6}>
                <h2 className="verification-text">Enter Verification code</h2>
                <p className="mb-2 mt-2">We’ve sent an Verification code to your registered email</p>

                <div style={{ display: "flex", gap: "10px" }}>
                  {otp.map((digit, index) => (
                    <input
                      key={index}
                      ref={(el) => (inputRefs.current[index] = el)}
                      type="text"
                      maxLength="1"
                      value={digit}
                      onChange={(e) => handleChange(e, index)}
                      onKeyDown={(e) => handleKeyDown(e, index)}
                      className="otp_input_box"
                    />
                  ))}
                </div>
                <p
                  className="resend-link"
                  onClick={handleResend}
                 
                >
                  Resend Verification code
                </p>
                <button
                  className="add_business_verify mt-3"
                  onClick={handleVerify}
                >
                  Verify Verification code
                </button>
              </Col>
              <Col md={3} />
            </Row>
          </div>
        </div>
      </div>

      <PrivacyTermsConditions />
    </>
  );
};

export default MyProfileAddBussinessPageOtp;
